import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { CigCupModalComponent } from './cig-cup-modal';

export const CigCupModalModule: string = ng
    .module('cig-cup-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('cigCupModalComponent', CigCupModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/cig-cup-modal/cig-cup-modal.module.ts